import { Trans, useTranslation } from 'react-i18next'

import { AlertDropDown, Divider, Text } from '@reveni-io/reveni-ui'

import useReturnGroup from '@/hooks/useReturnGroup/useReturnGroup'

import * as Styles from './styles'

const ReturnGroupReminder = ({ returnGroup, showDivider, paddingBottom, paddingTop }) => {
  const { t, i18n } = useTranslation()
  const { isCombiningReturns } = useReturnGroup({})

  if (!returnGroup || isCombiningReturns) return null

  const getFormattedOrderNames = () => {
    const listFormat = new Intl.ListFormat(i18n.language, { style: 'long', type: 'conjunction' })
    return listFormat.format(returnGroup.order_names)
  }

  return (
    <>
      {showDivider && <Divider />}
      <Styles.Container paddingBottom={paddingBottom} paddingTop={paddingTop}>
        <AlertDropDown options={{ withoutDropDown: true }} title={t('Estás combinando devoluciones')}>
          <Text type="bodySRegular">
            <Trans i18nKey="returnGroupOutput" values={{ orderNames: getFormattedOrderNames() }}>
              Por favor, devuelve los productos seleccionados junto con tu devolución del pedido{' '}
              <strong>{getFormattedOrderNames()}, en una sola caja, utilizando la misma etiqueta de devolución.</strong>
            </Trans>
          </Text>
        </AlertDropDown>
      </Styles.Container>
    </>
  )
}

export default ReturnGroupReminder
